export default {
  Search: {
    keyWordPlaceholder: '搜索域名/应用/IP'
  },
  ListTitle: {
    customer: '客户名称',
    gateWayAndBranch: '关联网关 / 分支机构',
    srcIp: '源IP',
    destDomainIpPort: '目标域名/IP/端口',
    destApp: '目标应用',
    protocol: '协议',
    upTraffic: '上行流量(byte)',
    downTraffic: '下行流量(byte)',
    accessTime: '访问时间',
  }
}